export const technologiesDetails = [
  {
    title: 'Angular & .NET',
    subtitle: 'Fast and responsive web apps',
    badges: ['Angular', '.NET Core', 'Blazor', 'REST API', 'SPA', 'TypeScript'],
    iconLink: 'assets/media/icons/angular-icon.svg',
    bgColor: '#FCD34D',
  },
  {
    title: 'Agile',
    subtitle: 'Agile development with transparent workflows',
    badges: ['Scrum', 'Kanban', 'Sprint Planning', 'Daily Standup', 'Retrospective'],
    iconLink: 'assets/media/icons/agile-icon.svg',
    bgColor: '#C4B5FD',
  },
  {
    title: 'Flutter, .NET MAUI',
    subtitle: 'Cross-platform mobile apps',
    badges: ['iOS & Android', 'C#', 'Dart', 'MVVM'],
    iconLink: 'assets/media/icons/flutter-icon.svg',
    bgColor: '#93C5FD',
  },
  {
    title: 'UI/UX',
    subtitle: 'Beautiful and user-friendly',
    badges: ['Responsive Design', 'Accessibility', 'User Flow', 'Wireframes', 'Prototyping'],
    iconLink: 'assets/media/icons/ui-icon.svg',
    bgColor: '#F9A8D4',
  },
  {
    title: 'Manual & Automated',
    subtitle: 'Full-cycle QA and testing',
    badges: ['Unit Testing', 'Integration Testing', 'E2E Tests', 'Manual QA', 'Automation'],
    iconLink: 'assets/media/icons/qa-icon.svg',
    bgColor: '#6EE7B7',
  },
  {
    title: 'Technical Documentation',
    subtitle: 'Complete technical documentation and user manuals',
    badges: ['User Manuals', 'API Docs', 'System Design', 'Architecture', 'Release Notes'],
    iconLink: 'assets/media/icons/docs-icon.svg',
    bgColor: '#FF8585',
  },
];

export const workWithUsItems = [
  {
    title: 'Our Vision',
    description: 'To be a long-term tech partner for companies looking to innovate, evolve, and scale with confidence',
  },
  {
    title: 'Our Mission',
    description:
      'To create high-performance digital products that help businesses grow, adapt, and thrive — using modern technologies and a human-centered approach.',
  },
];

export const particularities: any[] = [
  {
    icon: 'assets/media/icons/particularity1.svg',
    title: 'Full-Cycle Expertise',
    description: 'We cover every phase of the product journey — strategy, design, development, QA, deployment, and scaling',
  },
  {
    icon: 'assets/media/icons/particularity2.svg',
    title: 'Cross-Platform Focus',
  },
  {
    icon: 'assets/media/icons/particularity3.svg',
    title: 'Agile & Transparent',
  },
  {
    icon: 'assets/media/icons/particularity2.svg',
    title: 'Problem Solvers',
  },
  {
    icon: 'assets/media/icons/particularity4.svg',
    title: 'People-First Culture',
  },
  {
    icon: 'assets/media/icons/particularity5.svg',
    title: 'Lorem Ipsume',
  },
];

export const skills = [
  {
    title: 'UX/UI Design',
    subtitle: 'Flutter & .NET MAUI',
    highlight: 'Designs users love — built with empathy and strategy',
    description:
      'We create modern, intuitive interfaces focused on usability and conversion. Our UI/UX team blends aesthetics with function to turn ideas into smart, engaging user experiences.',
    features: [
      'User research and journey mapping',
      'Wireframes, mockups, and prototypes',
      'Visual design systems',
      'Responsive and mobile-first layouts',
      'Usability testing and feedback loops',
    ],
    bgColor: 'bg-info',
    rotateDeg: 'lg:rotate-[1deg]',
  },
  {
    title: 'Front-End Development',
    subtitle: 'Angular',
    highlight: 'Clean, dynamic, and scalable interfaces',
    description:
      'Our front-end team builds Angular applications that are fast, modular, and highly responsive. We ensure smooth interactions and pixel-perfect layouts across all screen sizes',
    features: [
      'Modular, component-driven structure',
      'State management and RxJS',
      'Cross-browser and cross-device compatibility',
      'RESTful API and GraphQL integration',
      'Performance optimization and lazy loading',
    ],
    bgColor: 'bg-warning',
    rotateDeg: 'lg:rotate-[2deg]',
  },
  {
    title: 'Back-End Development',
    subtitle: '.NET Full Stack',
    highlight: 'Robust architecture that scales with your business',
    description:
      'We leverage the Microsoft .NET ecosystem to build secure, high-performance server-side systems with clean APIs and seamless integrations',
    features: [
      'ASP.NET Core APIs and services',
      'Micro-services and cloud-ready solutions (Azure , AWS)',
      'Secure authentication (OAuth, JWT, Identity Server)',
      'Background processing and messaging queues',
      'Scalable hosting and deployment pipelines',
    ],
    bgColor: 'bg-success',
    rotateDeg: 'lg:rotate-[2deg]',
  },
  {
    title: 'Mobile App Development',
    subtitle: 'Flutter & .NET MAUI',
    highlight: 'Beautiful, high-performance apps — on every device',
    description:
      'We develop cross-platform mobile applications using Flutter and .NET MAUI, giving you native-like performance and sleek UI across Android and iOS — with a single codebase.',
    features: [
      'Flutter for rich, reactive UIs and fast iteration',
      '.NET MAUI for powerful enterprise-grade mobile apps',
      'Shared logic across platforms',
      'Offline support, local storage, and push notifications',
      'Integration with device hardware (camera, GPS, biometrics)',
      'App store deployment and post-launch support',
    ],
    bgColor: 'bg-error',
    rotateDeg: 'lg:-rotate-[2deg]',
  },
  {
    title: 'Testing & QA',
    subtitle: 'Manual + Automated',
    highlight: 'We break it — before your users can.',
    description:
      'Our QA process includes rigorous testing at every level — from individual components to full user flows. We catch issues early to ensure rock-solid reliability',
    features: [
      'Manual functional and regression testing',
      'Automated unit, integration, and UI testing',
      'End-to-end testing (web + mobile)',
      'Test case creation and coverage analysis',
      'CI/CD test integration and reporting',
    ],
    bgColor: 'bg-violet',
    rotateDeg: 'lg:-rotate-[3deg]',
  },
  {
    title: 'Database Design',
    subtitle: '',
    highlight: 'Structured, efficient, and secure data systems',
    description:
      'We design and optimize databases that scale smoothly and stay maintainable — no matter the complexity of your data model.',
    features: [
      'SQL (PostgreSQL, SQL Server) and NoSQL (MongoDB, Firebase)',
      'Data schema modeling and normalization',
      'Query optimization and indexing',
      'Secure access and data encryption',
      'Backup strategies and data integrity checks',
    ],
    bgColor: 'bg-orange',
    rotateDeg: 'lg:-rotate-[2deg]',
  },
  {
    title: 'Technical Documentation & User Guides',
    subtitle: '',
    highlight: 'Clear, structured, and professional documentation',
    description:
      'We don’t stop at writing code — we ensure your team and your users fully understand how to work with it. Our team prepares complete, high-quality documentation tailored to both developers and end-users.',
    features: [
      'System setup and configuration manuals',
      'User guides and onboarding materials',
      'Versioned documentation for product updates',
      'Clean formatting, visuals, and diagrams (when needed)',
      'Developer documentation (architecture, API, integration specs)',
    ],
    bgColor: 'bg-lime',
    rotateDeg: 'lg:rotate-[2deg]',
  },
  {
    title: 'Agile Methodology',
    subtitle: '',
    highlight: 'Speed + Flexibility = Real Progress',
    description:
      'We work in Agile frameworks to keep communication open and results consistent. Your feedback is built into every step of the process',
    features: [
      'Agile/Scrum workflows',
      'Sprint planning and demos',
      'Continuous delivery and fast iterations',
      'Transparent project tracking',
      'Adaptability to evolving goals',
    ],
    bgColor: 'bg-cyan',
    rotateDeg: 'lg:rotate-[1deg]',
  },
];

export const contactInfoItems = [
  { icon: 'phone', title: 'Call us', data: ['+373 693 97 993', '+373 693 97 993'] },
  { icon: 'pin', title: 'Visit us', data: ['45 Puskin str. office 700', 'MD-2005, Chisinau, Moldova'] },
  { icon: 'mail', title: 'Write us', data: ['office@sapec.md', 'info@sapec.md'] },
  { icon: 'message-circle', title: 'Chat with us', data: ['Contact our manager', 'Chat bot'] },
];
